import DiscountCodeContainer from './DiscountCodeContainer';

export default DiscountCodeContainer;
